import { render, staticRenderFns } from "./EmployeeFields.vue?vue&type=template&id=0a12d286"
import script from "./EmployeeFields.vue?vue&type=script&lang=js"
export * from "./EmployeeFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports